import React from 'react'
import logo from './logo.png'

export const Logo = () => {
  return (
    <img src={logo} height="82" alt="logo" />
  )
}
